document.addEventListener('DOMContentLoaded', function() {
  var megaMenus = document.querySelectorAll('.mega-menu');

  megaMenus.forEach(function(megaMenu) {
    var megaMenuContent = megaMenu.querySelector('.mega-menu__content');

    megaMenu.addEventListener('mouseenter', function() {
      this.setAttribute('open', '');
    });

    megaMenu.addEventListener('mouseleave', function(event) {
      if (!megaMenu.contains(event.relatedTarget)) {
        this.removeAttribute('open');
      }
    });

    megaMenuContent.addEventListener('mouseenter', function() {
      megaMenu.setAttribute('open', '');
    });

    megaMenuContent.addEventListener('mouseleave', function(event) {
      if (!megaMenuContent.contains(event.relatedTarget)) {
        megaMenu.removeAttribute('open');
      }
    });
  });
});

